(function ($) {
  'use strict';

  window.addEventListener('resize', function (event) {
    setSiteTopPadding();
  });

  $(document).ready(function () {
    setSiteTopPadding();
  });

  function setSiteTopPadding() {
    var logoHeight = parseInt($('.site-logo img').height(), 10);
    logoHeight = logoHeight > 22 ? logoHeight : 104;
    $('.site__main').css('padding-top', logoHeight + 'px');
  }

})(jQuery);
